import React from 'react';
import { Divider, Grid } from '@mui/material';
import { CardViewTextRow, CardViewDateRow } from 'ui/viewComponents';
import { isSubscriptionCancellationRequestedAction } from '../models/Action';
import { ActionCardBase } from './ActionCardBase';
import { ActionCardModalComponentProps } from './ActionCardModalComponent';
import { titleize } from 'lib/helpers';

const ActionCardSubscriptionCancellationRequested: React.FC<ActionCardModalComponentProps> = ({ action }) => {
    if (!isSubscriptionCancellationRequestedAction(action)) {
        return <ActionCardBase action={action} broken />;
    }

    const {
        subscriptionId,
        subscriptionSchemeId,
        cancelAt,
        cancelAtPeriodEnd,
        cancellationReason,
        cancellationFeedback,
        cancellationComment
    } = action.metadata;

    return (
        <ActionCardBase action={action} showDate>
            <Grid container spacing={1}>
                <Grid size={6}>
                    <CardViewTextRow title="Subscription ID" value={subscriptionId} noTransform />
                </Grid>
                <Grid size={6}>
                    <CardViewTextRow title="Scheme ID" value={subscriptionSchemeId} noTransform />
                </Grid>

                <Grid size={12}>
                    <Divider />
                </Grid>

                <Grid size={12}>
                    <CardViewDateRow
                        title="Cancellation Date"
                        value={cancelAt}
                        suffix={cancelAtPeriodEnd === true ? '(End of current billing period)' : ''}
                    />
                </Grid>

                {cancellationReason && (
                    <Grid size={cancellationFeedback ? 6 : 12}>
                        <CardViewTextRow
                            title="Reason"
                            value={titleize(cancellationReason.replace(/_/g, ' '))}
                        />
                    </Grid>
                )}
                {cancellationFeedback && (
                    <Grid size={6}>
                        <CardViewTextRow
                            title="Feedback"
                            value={titleize(cancellationFeedback.replace(/_/g, ' '))}
                        />
                    </Grid>
                )}

                {cancellationComment && (
                    <Grid size={12}>
                        <CardViewTextRow title="Comment" value={cancellationComment} />
                    </Grid>
                )}
            </Grid>
        </ActionCardBase>
    );
};

export default ActionCardSubscriptionCancellationRequested;
